<template>
  <section class="text-center">
    <img src="~images/support.png" alt="" height="80" width="80">

    <h1 v-if="tag === 'h1'" class="mt-3 mb-0 fw-normal lh-base title" v-html="title"></h1>
    <h2 v-else class="mt-3 mb-0 fw-normal lh-base title" v-html="title"></h2>
  </section>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },

    tag: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.title,
.title small {
  font-size: 1rem;
}

img {
  height: 60px;
  width: 60px;
}

@media (min-width: 576px) {
  .title small {
    font-size: 0.875em;
  }

  img {
    height: 80px;
    width: 80px;
  }
}

@media (min-width: 768px) {
  .title {
    font-size: 1.5rem;
  }
}

@media (min-width: 992px) {
  .title {
    font-size: 2rem;
  }
}
</style>